export const symbol_status_thai = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 405,
        Ypos_img: 300,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium breve`,
        Xpos_img: 405,
        Ypos_img: 367,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Bifidobacterium lactis`,
        Xpos_img: 405,
        Ypos_img: 432,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium longum`,
        Xpos_img: 405,
        Ypos_img: 497,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 405,
        Ypos_img: 562,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus gasseri`,
        Xpos_img: 405,
        Ypos_img: 627,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' }, 
        ]
    },
    {
        title: `Lactobacillus helveticus`,
        Xpos_img: 405,
        Ypos_img: 692,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus paracasei`,
        Xpos_img: 405,
        Ypos_img: 757,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus plantarum`,
        Xpos_img: 405,
        Ypos_img: 823,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 405,
        Ypos_img: 888,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 405,
        Ypos_img: 955,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Streptococcus thermophilus`,
        Xpos_img: 405,
        Ypos_img: 1025,
        page: 43,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]

export const symbol_status = [

]